module.exports = __webpack_public_path__ + "img/france-ill-defined-causes-female.d82acc80.png";